import { devDependencies } from "../package.json"

export default {
	frontVersion: devDependencies['front-version']
}
